import { useEffect } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";

// Components
import Header from "./components/Header";
import Footer from "./components/Footer";
import Seo from "./components/Seo";
import Landing from "./pages/landing/Landing";
import Portfolio from "./pages/portfolio/Portfolio";
import ProjectDetails from "./pages/portfolio/[project]/ProjectDetails";
import Resume from "./pages/resume/Resume";
import Contact from "./pages/contact/Contact";
import PageNotFound from "./pages/404/PageNotFound";
import profile from "./_data/profile.json";

function App() {
  const location = useLocation();

  // Scroll to the top on every route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Show a short title while the tab is in the background
  useEffect(() => {
    let pageTitle = document.title;
    const handleTabChange = () => {
      if (document.hidden) {
        pageTitle = document.title;
        document.title = `${profile.name} 👋`;
      } else {
        document.title = pageTitle;
      }
    };
    document.addEventListener("visibilitychange", handleTabChange);
    return () => document.removeEventListener("visibilitychange", handleTabChange);
  }, []);

  return (
    <>
      <Seo />
      <Header />
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Landing />} />
        <Route path="/ru" element={<Landing />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/portfolio/:projectSlug" element={<ProjectDetails />} />
        <Route path="/resume" element={<Resume />} />
        <Route path="/cv" element={<Navigate to="/resume" replace />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/page-not-found" element={<PageNotFound />} />
        {/* Fallback route for unknown paths */}
        <Route path="*" element={<Navigate to="/page-not-found" replace />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
